import { defineRouting } from "next-intl/routing";

export const pathnames = {
  "/": "/",
  "/archive": "/archive",
  "/assigned-to-me": "/assigned-to-me",
  "/chat": "/chat",
  "/checklists/templates": "/checklists/templates",
  "/complete-profile": "/complete-profile",
  "/files": "/files",
  "/grouped-projects": "/grouped-projects",
  "/sa-user-management": "/sa-user-management",
  "/settings/general": "/settings/general",
  "/profile": "/profile",
  "/profile/[userId]": "/profile/[userId]",
  "/profile/[userId]/permissions": "/profile/[userId]/permissions",
  "/profile/[userId]/skills": "/profile/[userId]/skills",
  "/shared-with-me": "/shared-with-me",
  "/usage-dashboard": "/usage-dashboard",
};

export const locales = ["en", "es"] as const;
export type Locale = (typeof locales)[number];

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (locales as readonly string[]).includes(value);
}

// Create and export the routing configuration
export const routing = defineRouting({
  locales,
  defaultLocale: "en",
  pathnames,
});
